/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../api/types.generated";
export type ApproveLotteryEntryMutationVariables = Types.Exact<{
  id: Types.Scalars["Float"];
}>;

export type ApproveLotteryEntryMutation = {
  approveLotteryEntry: Pick<Types.Success, "status">;
};

export const ApproveLotteryEntryDocument = gql`
  mutation ApproveLotteryEntry($id: Float!) {
    approveLotteryEntry(id: $id) {
      status
    }
  }
`;

/**
 * __useApproveLotteryEntryMutation__
 *
 * To run a mutation, you first call `useApproveLotteryEntryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveLotteryEntryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveLotteryEntryMutation, { data, loading, error }] = useApproveLotteryEntryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useApproveLotteryEntryMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    ApproveLotteryEntryMutation,
    ApproveLotteryEntryMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    ApproveLotteryEntryMutation,
    ApproveLotteryEntryMutationVariables
  >(ApproveLotteryEntryDocument, baseOptions);
}
export type ApproveLotteryEntryMutationHookResult = ReturnType<
  typeof useApproveLotteryEntryMutation
>;
export type ApproveLotteryEntryMutationResult =
  ApolloReactCommon.MutationResult<ApproveLotteryEntryMutation>;
export type ApproveLotteryEntryMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    ApproveLotteryEntryMutation,
    ApproveLotteryEntryMutationVariables
  >;
